// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__36KKJ","file":"styles_file__1jmBk"};